import Anchor from '../util/anchor';

class QuestionnaireController {
    constructor() {
        new Anchor();
        this.setTableAccordion();

        if (window.UA.isSP) {
            
            this.setSubNavSPChange();
            this.setSubNavSPAccordion();

            $('#js-table-of-contents-body').slideUp(16);
            $('#js-table-of-contents-toggle').removeClass('is-open');
            $('.q2021__table-of-contents-btn').removeClass('is-open');
            $('#js-table-of-contents-leader').removeClass('is-open');
        }
    }

    setSubNavSPChange() {
        let $header = $('#js-global-header');
        let $menu = $('.questionnaire-content__body-right');
        let headerHeight = $header.outerHeight();

        let controller = new ScrollMagic.Controller();
        let scene = new ScrollMagic.Scene({
            triggerElement: '.questionnaire-content__body',
            triggerHook: 'onLeave',
            reverse: true,
            offset: -headerHeight,
        }).addTo(controller);
        scene.on('enter', () => {
            $menu.addClass('is-fixed');
        });
        scene.on('leave', () => {
            $menu.removeClass('is-fixed');
        });
    }

    setSubNavSPAccordion() {
        let $btnBuyer = $('#js-accordion-btn-buyer');
        let $btnAgent = $('#js-accordion-btn-agent');
        let $contentBuyer = $('#js-accordion-content-buyer');
        let $contentAgent = $('#js-accordion-content-agent');
        
        let flag = 0;
        $contentBuyer.slideUp(16);
        $contentAgent.slideUp(16);

        $btnBuyer.on('click', function (e) {
            e.preventDefault();
            if (flag == 0) {
                flag = 1;
                $contentAgent.slideUp(250);
                $btnAgent.removeClass('is-open');
                $contentBuyer.slideToggle(250);
                $btnBuyer.toggleClass('is-open');

                setTimeout(function () {
                    flag = 0;
                }, 250);
            }
        });
        $btnAgent.on('click', function (e) { 
            e.preventDefault();
            if (flag == 0) {
                flag = 1;
                $contentBuyer.slideUp(250);
                $btnBuyer.removeClass('is-open');
                $contentAgent.slideToggle(250);
                $btnAgent.toggleClass('is-open');

                setTimeout(function () {
                    flag = 0;
                }, 250);
            }
        });
    }

    setTableAccordion() {
        let flag = 0;
        // $('#js-table-of-contents-body').slideUp(16);
        $('#js-table-of-contents-toggle').each(function () {
            let $this = $(this);
            $this.on('click', function (e) {
                e.preventDefault();
                if (flag == 0) {
                    flag = 1;
                    $this.toggleClass('is-open');
                    $('.q2021__table-of-contents-btn').toggleClass('is-open');
                    $('#js-table-of-contents-leader').toggleClass('is-open');
                    $('#js-table-of-contents-body').slideToggle(400, 'swing');

                    setTimeout(function () {
                        flag = 0;
                    }, 400);
                }
            });
        });
    }
}

export default QuestionnaireController;
